import React from "react";

export default function AiScore({ score, size = "md", label = "AI Score" }) {
  const s = score ?? 0;
  const tone = s >= 80 ? "text-success" : s >= 60 ? "text-brand" : s >= 40 ? "text-warning" : "text-muted-foreground";
  const sizes = {
    sm: { box: "h-14 w-14", num: "text-lg", ring: 3 },
    md: { box: "h-20 w-20", num: "text-2xl", ring: 4 },
    lg: { box: "h-28 w-28", num: "text-4xl", ring: 5 },
  }[size];
  const radius = 46;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (s / 100) * circ;

  return (
    <div className={`relative ${sizes.box} shrink-0`} data-testid="ai-score">
      <svg viewBox="0 0 100 100" className="h-full w-full -rotate-90">
        <circle cx="50" cy="50" r={radius} fill="none" stroke="hsl(var(--border))" strokeWidth={sizes.ring} />
        <circle
          cx="50" cy="50" r={radius} fill="none"
          stroke="hsl(var(--brand))" strokeWidth={sizes.ring} strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.16,1,0.3,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className={`font-mono font-bold ${sizes.num} ${tone}`}>{s}</span>
        {size !== "sm" && <span className="text-[9px] uppercase tracking-widest text-muted-foreground">/100</span>}
      </div>
    </div>
  );
}
